import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-catalog-scheme.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-catalog-scheme.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {UPDATE_CATALOG_BASE_SCHEME} from "./service-catalog-scheme.graphql";



@Injectable()
export class ServiceCatalogSchemeEffects {

  createServiceCatalogScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceCatalogSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_CATALOG_BASE_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceCatalogScheme({ serviceCatalogScheme: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceCatalogSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_CATALOG_BASE_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceCatalogScheme({ serviceCatalogScheme: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceCatalogSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceCatalogSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CATALOG_BASE_SCHEME,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing catalog based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceCatalogSchemes({ serviceCatalogSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  delete$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceCatalogScheme),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_CATALOG_SCHEMES,
        variables: {
          uniqueId: action?.catalogUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceCatalogScheme({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceCatalogSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceCatalogSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_CATALOG_SCHEMES,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing catalog based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceCatalogSchemes({ serviceCatalogSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
